import React, { useRef, useState } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import IliganMap from "../../image/Iligan-map.png";
import MarawiMap from "../../image/marawi-map.png";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";

export default function ContactPage() {
  const form = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsLoading(true); // Start loading
    emailjs
      .sendForm("service_ptyf1sf", "template_6b4z407", form.current, {
        publicKey: "w6Mvygwfe9u3Nh_pE",
      })
      .then(
        () => {
          Swal.fire({
            title: "Success!",
            text: "Your message has been successfully sent.",
            icon: "success",
            showConfirmButton: false, // Hides the confirm button
            timer: 2000, // Sets the timer to 2 seconds
            timerProgressBar: true, // Optional: Shows a progress bar
          });
          setIsLoading(false);
          form.current.reset();
        },
        (error) => {
          Swal.fire({
            title: "Error!",
            text: "Failed to send the message. Please try again.",
            icon: "error",
          });
          setIsLoading(false);
        }
      );
  };

  return (
    <div>
      <Navbar />
      <main className="responsive-padding">
        <div className="grid grid-cols-1  lg:grid-cols-2 gap-x-24 gap-y-10 pt-16 md:pt-20 ">
          <div className="">
            <h1 className="font-montserrat font-bold text-4xl md:text-[45px] leading-4 text-black">
              Get In Touch
            </h1>

            <p className="font-montserrat text-xs md:text-sm font-normal leading-6 tracking-[0.04em] my-8">
              Have questions or need more information? We're here to help! Reach
              out to us using the contact details below, and we'll get back to
              you as soon as possible.
            </p>

            <form className="my-5 " ref={form} onSubmit={sendEmail}>
              <div>
                <label
                  htmlFor="user_email"
                  className="font-montserrat font-medium text-base"
                >
                  Email
                </label>
                <input
                  type="email"
                  name="user_email"
                  id="user_email"
                  placeholder="ex. example@gmail.com"
                  className="w-full h-12 rounded-lg border border-black pl-5 bg-primary-light mt-1"
                  required
                />
              </div>{" "}
              <div className="mt-5">
                <label
                  htmlFor="subject"
                  className="font-montserrat font-medium text-base"
                >
                  Subject
                </label>
                <input
                  type="text"
                  name="subject"
                  id="subject"
                  placeholder="Subject"
                  className="w-full h-12 rounded-lg border border-black pl-5 bg-primary-light mt-1"
                  required
                />
              </div>{" "}
              <div className="mt-10">
                <label
                  htmlFor="message"
                  className="font-montserrat font-medium text-base text-grey-dark"
                >
                  Message
                </label>
                <textarea
                  name="message"
                  id="message"
                  placeholder="Enter your message here..."
                  className="w-full h-40 resize-none rounded-lg border border-black focus:border-primary transition duration-200 px-4 py-3 bg-primary-light mt-2 placeholder-grey-dark focus:outline-none"
                  aria-label="Enter your message"
                  required
                />
              </div>
              <button
                disabled={isLoading}
                type="submit"
                className={`uppercase bg-black w-full flex items-center justify-center font-montserrat font-base text-primary-light gap-3 py-2 rounded-[100px] mt-6
    ${
      isLoading
        ? "opacity-70 cursor-not-allowed hover:scale-100"
        : "hover:scale-105 hover:duration-200"
    }`}
              >
                {isLoading ? (
                  // 🔄 SPINNER
                  <div className="w-5 h-5 border-2 border-primary-light border-t-transparent rounded-full animate-spin"></div>
                ) : (
                  <>
                    <svg
                      width="18"
                      height="16"
                      viewBox="0 0 18 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.337891 15.25V0.75L17.5494 8L0.337891 15.25ZM1.83789 13L13.6879 8L1.83789 3V6.69225L7.26089 8L1.83789 9.30775V13Z"
                        fill="#E8EBE9"
                      />
                    </svg>
                  </>
                )}{" "}
                SUBMIT
              </button>
            </form>
          </div>
          <div className="grid grid-cols-1 gap-y-8 pb-12">
            {/* iligan */}
            <div className="w-full h-[312px] md:h-[320px] flex flex-col">
              <div className="w-full h-[35.3%] laptopSm:h-[45%] rounded-t-2xl">
                <img
                  src={IliganMap}
                  alt=""
                  className="w-full h-full object-cover object-center rounded-t-2xl"
                />
              </div>
              {/* location information */}
              <div
                className="h-[64.7%] laptopSm:h-[55%] bg-[#EEEEEE] px-6 py-6 laptopSm:px-10 rounded-b-2xl flex flex-col laptopSm:flex-row gap-3
            "
              >
                <div className="grid gap-3">
                  <div className="flex items-center gap-4">
                    {/* icon */}
                    <div className="w-[10%]">
                      <svg
                        width="22"
                        height="17"
                        viewBox="0 0 22 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.80775 12.9866C5.30258 12.9866 4.875 12.8286 4.525 12.5125C4.175 12.1964 4 11.8104 4 11.3544V2.42813C4 1.9721 4.175 1.58605 4.525 1.26999C4.875 0.953929 5.30258 0.795898 5.80775 0.795898H19.6923C20.1974 0.795898 20.625 0.953929 20.975 1.26999C21.325 1.58605 21.5 1.9721 21.5 2.42813V11.3544C21.5 11.8104 21.325 12.1964 20.975 12.5125C20.625 12.8286 20.1974 12.9866 19.6923 12.9866H5.80775ZM12.75 8.4992L5.5 3.77567V11.3544C5.5 11.4353 5.52883 11.5018 5.5865 11.5539C5.64417 11.6061 5.71792 11.6323 5.80775 11.6323H19.6923C19.7821 11.6323 19.8558 11.6061 19.9135 11.5539C19.9712 11.5018 20 11.4353 20 11.3544V3.77567L12.75 8.4992ZM12.75 6.84259L19.9038 2.20237C19.8846 2.18506 19.8638 2.17204 19.8413 2.16331C19.8189 2.15458 19.7885 2.15022 19.75 2.15022H5.75C5.718 2.15022 5.68592 2.15752 5.65375 2.17212C5.62175 2.18656 5.59617 2.20244 5.577 2.21975L12.75 6.84259ZM2.30775 16.1472C1.80258 16.1472 1.375 15.9892 1.025 15.6731C0.675 15.357 0.5 14.971 0.5 14.515V4.58163H2V14.515C2 14.5959 2.02883 14.6625 2.0865 14.7145C2.14417 14.7666 2.21792 14.7926 2.30775 14.7926H17.9423V16.1472H2.30775ZM20 3.73413C20 3.44005 19.9888 3.18042 19.9663 2.95527C19.9439 2.73011 19.9231 2.47915 19.9038 2.20237C19.8846 2.18506 19.8638 2.17204 19.8413 2.16331C19.8189 2.15458 19.7885 2.15022 19.75 2.15022H5.75C5.718 2.15022 5.68592 2.15752 5.65375 2.17212C5.62175 2.18656 5.59617 2.20244 5.577 2.21975C5.55767 2.49653 5.54 2.74599 5.524 2.96814C5.508 3.19043 5.5 3.44576 5.5 3.73413V2.15022H20V3.73413Z"
                          fill="#252525"
                        />
                      </svg>
                    </div>
                    <span className="font-montserrat text-xs leading-4">
                      jmif.inquiry@gmail.com{" "}
                    </span>
                  </div>{" "}
                  <div className="flex items-center gap-4">
                    {/* icon mobile*/}
                    <div className="w-[10%]">
                      <svg
                        width="18"
                        height="17"
                        viewBox="0 0 18 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.4402 16.1484C14.5557 16.1484 12.6625 15.7527 10.7605 14.9614C8.85867 14.17 7.11125 13.0537 5.51825 11.6125C3.92542 10.1711 2.69083 8.59304 1.8145 6.87833C0.938167 5.16378 0.5 3.45562 0.5 1.75386C0.5 1.48039 0.6 1.25253 0.8 1.07027C1 0.888005 1.25 0.796875 1.55 0.796875H4.8115C5.064 0.796875 5.28675 0.8713 5.47975 1.02015C5.67275 1.16885 5.7955 1.35261 5.848 1.57145L6.42125 4.22839C6.46092 4.47492 6.45258 4.68675 6.39625 4.8639C6.33975 5.04104 6.23842 5.18982 6.09225 5.31022L3.78275 7.34046C4.15442 7.95512 4.57908 8.5366 5.05675 9.08489C5.53425 9.63303 6.05125 10.1566 6.60775 10.6555C7.15642 11.1511 7.73975 11.6113 8.35775 12.0362C8.97575 12.4611 9.64308 12.8565 10.3598 13.2223L12.6038 11.1783C12.7603 11.0313 12.9498 10.9282 13.1723 10.869C13.3946 10.8101 13.6257 10.7956 13.8655 10.8257L16.6423 11.3364C16.8948 11.3966 17.1008 11.5129 17.2605 11.6854C17.4202 11.8579 17.5 12.0535 17.5 12.2724V15.2002C17.5 15.4711 17.3991 15.6969 17.1973 15.8775C16.9954 16.0581 16.7431 16.1484 16.4402 16.1484ZM3.073 6.05883L4.85775 4.51668C4.88975 4.49351 4.91058 4.46167 4.92025 4.42119C4.92992 4.3807 4.92833 4.34307 4.9155 4.30831L4.48075 2.29026C4.46792 2.24406 4.4455 2.20936 4.4135 2.18619C4.3815 2.16301 4.33983 2.15142 4.2885 2.15142H2.15C2.1115 2.15142 2.07942 2.16301 2.05375 2.18619C2.02825 2.20936 2.0155 2.23834 2.0155 2.2731C2.06667 2.89017 2.1785 3.51703 2.351 4.15366C2.52333 4.79045 2.764 5.42551 3.073 6.05883ZM11.773 13.863C12.4358 14.1421 13.1272 14.3554 13.847 14.5031C14.567 14.6506 15.2397 14.7382 15.8652 14.7661C15.9037 14.7661 15.9358 14.7545 15.9615 14.7313C15.9872 14.7081 16 14.6792 16 14.6444V12.7446C16 12.6983 15.9872 12.6607 15.9615 12.6318C15.9358 12.6029 15.8974 12.5826 15.8462 12.571L13.7462 12.1854C13.7077 12.1739 13.6741 12.1724 13.6453 12.1812C13.6164 12.1899 13.5859 12.2087 13.5538 12.2376L11.773 13.863Z"
                          fill="#252525"
                        />
                      </svg>
                    </div>
                    <span className="font-montserrat text-xs leading-4">
                      +639771964178
                    </span>
                  </div>{" "}
                  <div className="flex gap-4">
                    {/* icon location*/}
                    <div className="w-[10%]">
                      <svg
                        width="14"
                        height="18"
                        viewBox="0 0 14 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7 17.9486C5.31033 17.9486 3.92958 17.7296 2.85775 17.2916C1.78592 16.8537 1.25 16.2883 1.25 15.5955C1.25 15.2748 1.38367 14.9732 1.651 14.6907C1.91833 14.4082 2.28792 14.1656 2.75975 13.9631L3.9405 14.9304C3.72633 15.0079 3.50125 15.1046 3.26525 15.2203C3.02942 15.3362 2.86792 15.4583 2.78075 15.5867C2.94608 15.8566 3.43808 16.0919 4.25675 16.2927C5.07525 16.4936 5.98808 16.594 6.99525 16.594C8.00225 16.594 8.91925 16.4936 9.74625 16.2927C10.5731 16.0919 11.0693 15.8566 11.2348 15.5867C11.1501 15.449 10.9793 15.3223 10.7223 15.2065C10.4651 15.0908 10.2212 14.9941 9.9905 14.9164L11.1557 13.9353C11.6672 14.1472 12.0608 14.3944 12.3365 14.6769C12.6122 14.9594 12.75 15.2643 12.75 15.5917C12.75 16.2857 12.2141 16.8519 11.1423 17.2905C10.0704 17.7292 8.68967 17.9486 7 17.9486ZM7.025 13.5463C8.68133 12.4129 9.92458 11.2902 10.7548 10.1782C11.5849 9.06616 12 7.96198 12 6.8657C12 5.30752 11.4599 4.13133 10.3798 3.33711C9.29958 2.54274 8.17458 2.14556 7.00475 2.14556C5.83492 2.14556 4.70833 2.54297 3.625 3.33779C2.54167 4.13245 2 5.30925 2 6.86818C2 7.89222 2.40992 8.95418 3.22975 10.0541C4.04958 11.154 5.31467 12.318 7.025 13.5463ZM7 15.2395C4.81783 13.7662 3.189 12.3354 2.1135 10.9469C1.03783 9.55869 0.5 8.19872 0.5 6.86706C0.5 5.86123 0.6965 4.98032 1.0895 4.22434C1.4825 3.46835 1.98983 2.83533 2.6115 2.32526C3.23333 1.81535 3.931 1.43217 4.7045 1.17571C5.47783 0.919245 6.2435 0.791016 7.0015 0.791016C7.7595 0.791016 8.52467 0.919245 9.297 1.17571C10.0695 1.43217 10.7667 1.81535 11.3885 2.32526C12.0102 2.83533 12.5175 3.46858 12.9105 4.22501C13.3035 4.98145 13.5 5.86168 13.5 6.8657C13.5 8.19752 12.9622 9.55771 11.8865 10.9463C10.811 12.3348 9.18217 13.7659 7 15.2395ZM7.00475 8.37128C7.50025 8.37128 7.92458 8.21325 8.27775 7.89719C8.63108 7.58113 8.80775 7.19644 8.80775 6.74311C8.80775 6.28994 8.63075 5.9039 8.27675 5.58498C7.92275 5.26591 7.49717 5.10637 7 5.10637C6.50767 5.10637 6.08333 5.26621 5.727 5.58588C5.3705 5.9057 5.19225 6.29002 5.19225 6.73883C5.19225 7.19501 5.3705 7.58113 5.727 7.89719C6.08333 8.21325 6.50925 8.37128 7.00475 8.37128Z"
                          fill="#1C1B1F"
                        />
                      </svg>
                    </div>
                    <div className="w-[90%] font-montserrat text-xs leading-4">
                      <h6 className="">Iligan</h6>
                      <h6 className="mt-3 ">
                        BH Building, Sabayle, Iligan City, Lanao del Norte
                      </h6>
                    </div>
                  </div>
                </div>
                <div className="mt-auto w-full laptopSm:w-1/2  flex">
                  <a
                    href="https://www.google.com/maps/place/J.M.I.F-+Jamiatu+Marawi+Al-Islamia+Foundation.+(SATELLITE)/@8.2308241,124.2384698,21z/data=!4m6!3m5!1s0x325575000527e02b:0xf70144a947025fc!8m2!3d8.2309475!4d124.2386194!16s%2Fg%2F11w4brnlsr?entry=ttu&g_ep=EgoyMDI0MDkwNC4wIKXMDSoASAFQAw%3D%3D"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full laptop:w-[158px] laptopMd:ml-auto  max-w-screen-laptop bg-secondary-normal font-montserrat font-semibold text-sm text-white capitalize shadow-custom text-center py-2 rounded-[100px]"
                  >
                    {" "}
                    <button>view map</button>
                  </a>
                </div>
              </div>
            </div>{" "}
            {/* Marawi */}
            <div className="w-full h-[312px] md:h-[320px] flex flex-col">
              <div className="w-full h-[35.3%] laptopSm:h-[45%] rounded-t-2xl">
                <img
                  src={MarawiMap}
                  alt=""
                  className="w-full h-full object-cover object-center rounded-t-2xl"
                />
              </div>
              {/* location information */}
              <div
                className="h-[64.7%] laptopSm:h-[55%] bg-grey-normalHover  px-6 py-6 laptopSm:px-10 rounded-b-2xl flex flex-col laptopSm:flex-row gap-3
            "
              >
                <div className="grid gap-3">
                  <div className="flex items-center gap-4">
                    {/* icon */}
                    <div className="w-[10%]">
                      <svg
                        width="22"
                        height="17"
                        viewBox="0 0 22 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.80775 12.9866C5.30258 12.9866 4.875 12.8286 4.525 12.5125C4.175 12.1964 4 11.8104 4 11.3544V2.42813C4 1.9721 4.175 1.58605 4.525 1.26999C4.875 0.953929 5.30258 0.795898 5.80775 0.795898H19.6923C20.1974 0.795898 20.625 0.953929 20.975 1.26999C21.325 1.58605 21.5 1.9721 21.5 2.42813V11.3544C21.5 11.8104 21.325 12.1964 20.975 12.5125C20.625 12.8286 20.1974 12.9866 19.6923 12.9866H5.80775ZM12.75 8.4992L5.5 3.77567V11.3544C5.5 11.4353 5.52883 11.5018 5.5865 11.5539C5.64417 11.6061 5.71792 11.6323 5.80775 11.6323H19.6923C19.7821 11.6323 19.8558 11.6061 19.9135 11.5539C19.9712 11.5018 20 11.4353 20 11.3544V3.77567L12.75 8.4992ZM12.75 6.84259L19.9038 2.20237C19.8846 2.18506 19.8638 2.17204 19.8413 2.16331C19.8189 2.15458 19.7885 2.15022 19.75 2.15022H5.75C5.718 2.15022 5.68592 2.15752 5.65375 2.17212C5.62175 2.18656 5.59617 2.20244 5.577 2.21975L12.75 6.84259ZM2.30775 16.1472C1.80258 16.1472 1.375 15.9892 1.025 15.6731C0.675 15.357 0.5 14.971 0.5 14.515V4.58163H2V14.515C2 14.5959 2.02883 14.6625 2.0865 14.7145C2.14417 14.7666 2.21792 14.7926 2.30775 14.7926H17.9423V16.1472H2.30775ZM20 3.73413C20 3.44005 19.9888 3.18042 19.9663 2.95527C19.9439 2.73011 19.9231 2.47915 19.9038 2.20237C19.8846 2.18506 19.8638 2.17204 19.8413 2.16331C19.8189 2.15458 19.7885 2.15022 19.75 2.15022H5.75C5.718 2.15022 5.68592 2.15752 5.65375 2.17212C5.62175 2.18656 5.59617 2.20244 5.577 2.21975C5.55767 2.49653 5.54 2.74599 5.524 2.96814C5.508 3.19043 5.5 3.44576 5.5 3.73413V2.15022H20V3.73413Z"
                          fill="#fef7fa"
                        />
                      </svg>
                    </div>
                    <span className="font-montserrat text-xs leading-4 text-secondary-light">
                      jmif.inquiry@gmail.com{" "}
                    </span>
                  </div>{" "}
                  <div className="flex items-center gap-4">
                    {/* icon mobile*/}
                    <div className="w-[10%]">
                      <svg
                        width="18"
                        height="17"
                        viewBox="0 0 18 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.4402 16.1484C14.5557 16.1484 12.6625 15.7527 10.7605 14.9614C8.85867 14.17 7.11125 13.0537 5.51825 11.6125C3.92542 10.1711 2.69083 8.59304 1.8145 6.87833C0.938167 5.16378 0.5 3.45562 0.5 1.75386C0.5 1.48039 0.6 1.25253 0.8 1.07027C1 0.888005 1.25 0.796875 1.55 0.796875H4.8115C5.064 0.796875 5.28675 0.8713 5.47975 1.02015C5.67275 1.16885 5.7955 1.35261 5.848 1.57145L6.42125 4.22839C6.46092 4.47492 6.45258 4.68675 6.39625 4.8639C6.33975 5.04104 6.23842 5.18982 6.09225 5.31022L3.78275 7.34046C4.15442 7.95512 4.57908 8.5366 5.05675 9.08489C5.53425 9.63303 6.05125 10.1566 6.60775 10.6555C7.15642 11.1511 7.73975 11.6113 8.35775 12.0362C8.97575 12.4611 9.64308 12.8565 10.3598 13.2223L12.6038 11.1783C12.7603 11.0313 12.9498 10.9282 13.1723 10.869C13.3946 10.8101 13.6257 10.7956 13.8655 10.8257L16.6423 11.3364C16.8948 11.3966 17.1008 11.5129 17.2605 11.6854C17.4202 11.8579 17.5 12.0535 17.5 12.2724V15.2002C17.5 15.4711 17.3991 15.6969 17.1973 15.8775C16.9954 16.0581 16.7431 16.1484 16.4402 16.1484ZM3.073 6.05883L4.85775 4.51668C4.88975 4.49351 4.91058 4.46167 4.92025 4.42119C4.92992 4.3807 4.92833 4.34307 4.9155 4.30831L4.48075 2.29026C4.46792 2.24406 4.4455 2.20936 4.4135 2.18619C4.3815 2.16301 4.33983 2.15142 4.2885 2.15142H2.15C2.1115 2.15142 2.07942 2.16301 2.05375 2.18619C2.02825 2.20936 2.0155 2.23834 2.0155 2.2731C2.06667 2.89017 2.1785 3.51703 2.351 4.15366C2.52333 4.79045 2.764 5.42551 3.073 6.05883ZM11.773 13.863C12.4358 14.1421 13.1272 14.3554 13.847 14.5031C14.567 14.6506 15.2397 14.7382 15.8652 14.7661C15.9037 14.7661 15.9358 14.7545 15.9615 14.7313C15.9872 14.7081 16 14.6792 16 14.6444V12.7446C16 12.6983 15.9872 12.6607 15.9615 12.6318C15.9358 12.6029 15.8974 12.5826 15.8462 12.571L13.7462 12.1854C13.7077 12.1739 13.6741 12.1724 13.6453 12.1812C13.6164 12.1899 13.5859 12.2087 13.5538 12.2376L11.773 13.863Z"
                          fill="#fdf1fa"
                        />
                      </svg>
                    </div>
                    <span className="font-montserrat text-xs leading-4 text-secondary-light">
                      +639771964178
                    </span>
                  </div>{" "}
                  <div className="flex gap-4">
                    {/* icon location*/}
                    <div className="w-[10%]">
                      <svg
                        width="14"
                        height="18"
                        viewBox="0 0 14 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7 17.9486C5.31033 17.9486 3.92958 17.7296 2.85775 17.2916C1.78592 16.8537 1.25 16.2883 1.25 15.5955C1.25 15.2748 1.38367 14.9732 1.651 14.6907C1.91833 14.4082 2.28792 14.1656 2.75975 13.9631L3.9405 14.9304C3.72633 15.0079 3.50125 15.1046 3.26525 15.2203C3.02942 15.3362 2.86792 15.4583 2.78075 15.5867C2.94608 15.8566 3.43808 16.0919 4.25675 16.2927C5.07525 16.4936 5.98808 16.594 6.99525 16.594C8.00225 16.594 8.91925 16.4936 9.74625 16.2927C10.5731 16.0919 11.0693 15.8566 11.2348 15.5867C11.1501 15.449 10.9793 15.3223 10.7223 15.2065C10.4651 15.0908 10.2212 14.9941 9.9905 14.9164L11.1557 13.9353C11.6672 14.1472 12.0608 14.3944 12.3365 14.6769C12.6122 14.9594 12.75 15.2643 12.75 15.5917C12.75 16.2857 12.2141 16.8519 11.1423 17.2905C10.0704 17.7292 8.68967 17.9486 7 17.9486ZM7.025 13.5463C8.68133 12.4129 9.92458 11.2902 10.7548 10.1782C11.5849 9.06616 12 7.96198 12 6.8657C12 5.30752 11.4599 4.13133 10.3798 3.33711C9.29958 2.54274 8.17458 2.14556 7.00475 2.14556C5.83492 2.14556 4.70833 2.54297 3.625 3.33779C2.54167 4.13245 2 5.30925 2 6.86818C2 7.89222 2.40992 8.95418 3.22975 10.0541C4.04958 11.154 5.31467 12.318 7.025 13.5463ZM7 15.2395C4.81783 13.7662 3.189 12.3354 2.1135 10.9469C1.03783 9.55869 0.5 8.19872 0.5 6.86706C0.5 5.86123 0.6965 4.98032 1.0895 4.22434C1.4825 3.46835 1.98983 2.83533 2.6115 2.32526C3.23333 1.81535 3.931 1.43217 4.7045 1.17571C5.47783 0.919245 6.2435 0.791016 7.0015 0.791016C7.7595 0.791016 8.52467 0.919245 9.297 1.17571C10.0695 1.43217 10.7667 1.81535 11.3885 2.32526C12.0102 2.83533 12.5175 3.46858 12.9105 4.22501C13.3035 4.98145 13.5 5.86168 13.5 6.8657C13.5 8.19752 12.9622 9.55771 11.8865 10.9463C10.811 12.3348 9.18217 13.7659 7 15.2395ZM7.00475 8.37128C7.50025 8.37128 7.92458 8.21325 8.27775 7.89719C8.63108 7.58113 8.80775 7.19644 8.80775 6.74311C8.80775 6.28994 8.63075 5.9039 8.27675 5.58498C7.92275 5.26591 7.49717 5.10637 7 5.10637C6.50767 5.10637 6.08333 5.26621 5.727 5.58588C5.3705 5.9057 5.19225 6.29002 5.19225 6.73883C5.19225 7.19501 5.3705 7.58113 5.727 7.89719C6.08333 8.21325 6.50925 8.37128 7.00475 8.37128Z"
                          fill="#fdf1fa"
                        />
                      </svg>
                    </div>
                    <div className="w-[90%] font-montserrat text-xs leading-4 text-secondary-light">
                      <h6 className="">Main Campus</h6>
                      <h6 className="mt-3 ">
                        Moncado Kadingilan, Marawi City, Lanao Del Sur
                      </h6>
                    </div>
                  </div>
                </div>
                <div className="mt-auto w-full laptopSm:w-1/2  flex">
                  {/* */}
                  <a
                    href="https://maps.app.goo.gl/67n6s5jEo8FDFzYM6"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full laptop:w-[158px] laptopMd:ml-auto  max-w-screen-laptop bg-secondary-normal font-montserrat font-semibold text-sm text-white capitalize shadow-custom text-center py-2 rounded-[100px]"
                  >
                    <button>view map</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
